import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import api from "../lib/api";
import { setAuth } from "../lib/auth";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await api.post("/auth/admin/login", { email, password });
      setAuth(r.data.token, r.data.admin, "admin");
      navigate("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Inloggning misslyckades");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <Header />
      <div className="max-w-md mx-auto px-4 py-16">
        <ShieldCheck className="w-10 h-10 text-brand mb-4" />
        <p className="label-overline mb-2">Admin</p>
        <h1 className="font-display font-black uppercase text-white text-4xl mb-6">Plattformsadmin</h1>
        <form onSubmit={submit} className="card-surface p-6 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="label-overline block mb-1">E-post</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-field"
              data-testid="admin-email"
            />
          </div>
          <div>
            <label className="label-overline block mb-1">Lösenord</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
              data-testid="admin-password"
            />
          </div>
          {err && <p className="text-destructive text-sm" data-testid="admin-login-error">{err}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="admin-login-submit">
            {loading ? "Loggar in..." : "Logga in"}
          </button>
          <div className="text-right">
            <Link to="/forgot-password" className="text-xs text-white/60 hover:text-brand" data-testid="admin-forgot-link">
              Glömt lösenord?
            </Link>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
}
